module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/review-d089151b8f5e1ec79c84adb11b64729e.png";